import Axios from "axios";
import token from "./setToken";

export default {
  async makeAnswerSheet(surveyId, memberNo, branch) {
    try {
      let params = new URLSearchParams();
      params.append("surveyId", JSON.stringify(surveyId));
      params.append("memberNo", JSON.stringify(memberNo));
      params.append("branch", JSON.stringify(branch));
      return await Axios.post(`/api/CreateRefrigerantAnswerSheet`, params,  token.setTokenToHeader());
    } catch (error) {
      console.error("冷媒調査の回答票を作成できません[makeAnswerSheet]");
      throw error;
    }
  },
};
